import { Badge, Icon, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { FeatureValue } from "./types";

interface FeatureCellProps {
  value: FeatureValue;
  isCurrentPlan: boolean;
  isOddRow: boolean;
}

export const FeatureCell = ({ value, isCurrentPlan, isOddRow }: FeatureCellProps) => {
  const bgColor = isCurrentPlan ? (isOddRow ? "bg-primary-tint-dark" : "bg-primary-tint-light") : isOddRow ? "bg-neutral-gray" : "bg-white";

  const renderContent = () => {
    switch (value.type) {
      case "boolean":
        return value.available ? (
          <Icon className="flex-shrink-0 text-success" name="TickCircle" variant="Bold" size="md" />
        ) : (
          <Icon className="flex-shrink-0 text-neutral-dark-gray" name="CloseCircle" variant="Bold" size="md" />
        );

      case "badge":
        return <Badge type={value.variant} message={value.label} size="sm" />;

      case "text":
        return (
          <Typography variant="small-regular" className="whitespace-pre-line text-center">
            {value.content}
          </Typography>
        );
    }
  };

  return (
    <td className={clsx("px-2.5 py-2", bgColor)}>
      <div className="flex items-center justify-center">{renderContent()}</div>
    </td>
  );
};
